import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { CombinedCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { isCombinedCondition } from "@app/util/viewModel/assert";

export const getCombinedConditionsCount = (
  condition: CombinedCondition,
  implicitFilterFieldsNames: Set<IField["filterName"]>
): number =>
  condition.conditions.reduce(
    (result, condition) =>
      result +
      (isCombinedCondition(condition)
        ? getCombinedConditionsCount(condition, implicitFilterFieldsNames)
        : !implicitFilterFieldsNames.has(condition.fieldFilterName) && condition.operator
          ? 1
          : 0),
    0
  );
